import React from 'react';
import { node } from 'prop-types';
import cx from 'classnames';

import Bar, { BarItem } from './../Bar';

const propTypes = {
  title: node,
  closeButton: node,
};

const CLASS_ROOT = 'dialog__header';

const CardHeader = ({
  className,
  children,
  title,
  closeButton = (
    <button type="button" data-a11y-dialog-hide aria-label="Close the dialog">
      &times;
    </button>
  ),
  ...other
}) => {
  const classes = cx(CLASS_ROOT, className);
  const cardTitle = typeof title === 'string' ? <h2>{title}</h2> : title;

  const headerBar = (
    <Bar>
      <BarItem isFilling>{cardTitle}</BarItem>
      {closeButton && <BarItem>{closeButton}</BarItem>}
    </Bar>
  );

  return (
    <div className={classes} {...other}>
      {headerBar}
      {children}
    </div>
  );
};

CardHeader.displayName = 'CardHeader';
CardHeader.propTypes = propTypes;

export default CardHeader;



// WEBPACK FOOTER //
// ./src/components/Dialog/DialogHeader.js